var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlumbing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4669 4.70032L16.4169 7.65033C17.3919 6.67533 17.3919 5.09199 16.4169 4.11699L13.4669 1.16699L9.93359 4.70032L11.7003 6.46699L13.4669 4.70032Z",
    fill: "#017a4e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98141 7.64457L4.03516 10.5908L5.80291 12.3586L8.74916 9.41232L6.98141 7.64457Z",
    fill: "#017a4e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8746 6.46673L11.6996 7.64173L8.15794 4.1084L6.39128 5.87507L9.92461 9.4084L2.84961 16.4834L5.20794 18.8417L14.0496 10.0001L14.6413 10.5917L15.8163 9.41673L12.8746 6.46673Z",
    fill: "#017a4e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlumbing);
export default __webpack_public_path__ + "static/media/plumbing.105c5a556258a4d17d8568436fac2476.svg";
export { ForwardRef as ReactComponent };